export const FOREX_DRAFT_MODULE_NAME: string = 'draft';

export enum ForexDraftGetter {
	list = 'list',
	loading = 'loading',
	operationType = 'operationType',
	currency = 'currency',
	dateFrom = 'dateFrom',
	dateTo = 'dateTo',
}

export enum ForexDraftMutation {
	addDraftList = 'addDraftList',
	setDraftLoading = 'setDraftLoading',
	deleteDraft = 'deleteDraft',
	setNextPage = 'setNextPage',
	resetPage = 'resetPage',
	resetFilter = 'resetFilter',
	setIsEndPage = 'setIsEndPage',
	setOperationType = 'setOperationType',
	setCurrency = 'setCurrency',
	setDateFrom = 'setDateFrom',
	setDateTo = 'setDateTo',
}

export enum ForexDraftAction {
	loadDraftNextPage = 'loadDraftNextPage',
	loadPage = 'loadPage',
	reloadPage = 'reloadPage',
	fetchDeleteDraft = 'fetchDeleteDraft',
}